var chunkToChildrenMap = {
	"85": [
		18,
		219,
		178,
		619
	],
	"178": [
		18,
		219,
		485,
		72,
		645
	],
	"732": [
		18
	],
	"955": [
		18,
		219,
		998,
		732,
		980,
		862,
		744
	],
	"998": [
		18,
		318
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));